<script setup lang="ts">
import { useRouter } from 'vue-router'
import type {ISonuc} from '@/model/sonuc'
import { saatFormat, saniyeFormat } from '@/utils/ExDate.ts'

interface Props {
  sonuc?: ISonuc | null
}
defineProps<Props>()

const router = useRouter()
</script>

<template>
 <div
    class="flex flex-col items-center justify-start w-full gap-4"
  >

   <div
    class="card w-full p-3 md:p-6 space-y-2 flex flex-col items-center justify-center px-4 md:px-6"
  >
    <span class="inline-flex items-center gap-2 rounded-full p-3 bg-gray-50">
      <MIcon name="trophy" size="20px" class="text-gray-800" />
    </span>
    <h2 class="text-title-md text-blue-600">{{ $t('competition_completed.title') }}</h2>
    <p
      class="text-body-md text-gray-700 mt-2 override-font-family"
    >
      Sıralama sonuçları açıklanana kadar beklemede kalın.
    </p>

    <div v-if="sonuc" class="flex flex-col items-center justify-center mt-10 w-full gap-2">
      <div class="flex flex-row items-center justify-between mt-2 w-full">
        <p class="text-body-md text-gray-700">{{ $t('result.exam_duration') }}</p>
          <p class="text-body-md text-gray-400">{{ saniyeFormat(sonuc?.toplam_sure) || '-' }}</p>
      </div>
      <div class="flex flex-row items-center justify-between mt-2 w-full">
        <p class="text-body-md text-gray-700">{{ $t('result.exam_start') }}</p>
          <p class="text-body-md text-gray-400">{{ saatFormat(sonuc?.baslama_zamani) || '-' }}</p>
      </div>
      <div class="flex flex-row items-center justify-between mt-2 w-full">
        <p class="text-body-md text-gray-700">{{ $t('result.exam_end') }}</p>
          <p class="text-body-md text-gray-400">{{ saatFormat(sonuc?.bitirme_zamani) || '-' }}</p>
      </div>
    </div>
  </div>

  <div
    class="card w-full p-4 md:p-6 space-y-4 flex flex-col items-center justify-center px-4 md:px-6"
  >
    <div class="flex flex-col items-center justify-center gap-2">
      <span class="inline-flex items-center justify-center rounded-full bg-gray-50 size-11">
        <MIcon name="quiz" size="24px" class="text-black" />
      </span>
      <h2 class="text-title-md text-blue-600 text-center">Cevap Anahtarı</h2>
      <p class="text-body-md text-gray-700 text-center override-font-family">Sorularınızı kontrol edebilirsiniz.</p>
    </div>

    <div class="w-full flex gap-3 items-center justify-center">
      <!-- Doğru -->
      <div class="flex-1 flex items-center justify-center gap-2 bg-green-100 rounded-xl p-3">
        <MIcon name="check_circle" size="16px" class="text-green-700 leading-4.5" filled />
        <span class="text-label-sm text-green-700 whitespace-nowrap"><span class="font-bold">{{ sonuc?.dogru_sayisi}}</span> Doğru</span>
      </div>

      <!-- Yanlış -->
      <div class="flex-1 flex items-center justify-center gap-2 bg-red-100 rounded-xl p-3">
        <MIcon name="cancel" size="16px" class="text-red-600 leading-4.5" filled />
        <span class="text-label-sm  text-red-600 whitespace-nowrap"><span class="font-bold">{{ sonuc?.yanlis_sayisi }}</span> Yanlış</span>
      </div>

      <!-- Boş -->
      <div class="flex-1 flex items-center justify-center gap-2 bg-amber-100 rounded-xl p-3">
        <MIcon name="remove_circle" size="16px" class="text-amber-600 leading-4.5" filled />
        <span class="text-label-sm  text-amber-600 whitespace-nowrap"><span class="font-bold">{{ sonuc?.bos_sayisi }}</span> Boş</span>
      </div>
    </div>

    <button class="btn btn-status-default w-full bg-gray-100 hover:bg-gray-200 text-gray-800 border-none py-3 h-auto" @click="router.push('/sonuc')">
      {{ $t('result.review_questions') }}
    </button>
  </div>
  </div>
</template>

<style scoped>
</style>
